import { z } from 'zod'

export const CreateGitClubCredentialSchema = z.object({
  user: z.string().min(3, { message: 'settings.federationClubApi.userNameMinLength' }),
  password: z.string().min(6, { message: 'settings.federationClubApi.passwordMinLength' }),
  clubGuid: z.string().min(1, { message: 'settings.federationClubApi.clubGuidRequired' }),
})
